import { get, post } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

export default () => ({
  getCompanyData(companyId) {
    return get(`/members-api/partner/companies/${companyId}`)
  },
  getPartnerCompanies(page, sortProperty, filter, search) {
    return get(
      buildURL('/members-api/partner/companies', {
        page,
        sort: sortProperty,
        filter,
        search,
      })
    )
  },
  getPartnerStatistics() {
    return get('/members-api/partner/statistics')
  },
  addPartnerCompany(company) {
    return post('/members-api/partner/companies', company)
  },
  getPartnerIncidents(feDateRange) {
    return post(`/members-api/partner/incidents`, { feDateRange })
  },
  fetchTenantData(tenantId, companyId = '') {
    return get(`/members-api/partner/plans/${tenantId}?companyFilter=${companyId}`)
  },
  editTenant(tenantId, data, companyId = '') {
    return post(`/members-api/partner/plans/${tenantId}?companyFilter=${companyId}`, data)
  },
  migrateCompany(releasingBrandId, acquiringBrandId, companyId) {
    return post(`/members-api/partner/migrate/`, {
      releasingBrandCompanyId: releasingBrandId,
      acquiringBrandCompanyId: acquiringBrandId,
      migratingCompanyId: companyId,
    })
  },
  fetchPossibleAcquiringPartners() {
    return get(`/members-api/partner/migrate/`)
  },
})
